export const ReportType = {
    BOARD: "board",
    DONOR: "donor",
    PROGRAMME: "programme",
    TRANSACTIONS: "transactions",
};
//# sourceMappingURL=index.js.map